import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/[locale]/mobile-app/mobileApp.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppFeature"] */ "/opt/build/repo/src/components/AppFeature/AppFeature.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/ui/Banner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ButtonLink"] */ "/opt/build/repo/src/components/ui/Button/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageContent"] */ "/opt/build/repo/src/components/ui/PageContent/PageContent.tsx");
